import { MANIFESTO } from "../data/content";
import { Reveal } from "../components/Reveal";

export default function Manifesto() {
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="manifesto-section">
      <div className="container-x grid md:grid-cols-12 gap-10">
        {/* Sticky heading */}
        <div className="md:col-span-4">
          <div className="md:sticky md:top-28">
            <p className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-4">
              Our manifesto
            </p>
            <h2 className="font-heading font-extrabold tracking-tight text-4xl md:text-5xl leading-[0.95]">
              Why we built <span className="text-[#0033A2]">grooh</span>.
            </h2>
            <p className="mt-6 text-black/60 font-medium leading-relaxed">
              Four beliefs that shape every pixel and every feature we ship.
            </p>
          </div>
        </div>

        {/* Scrolling chapters */}
        <div className="md:col-span-8 md:col-start-5 space-y-14 md:space-y-20">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={0.05}>
              <div
                className="border-t-2 border-black pt-8 md:flex gap-8"
                data-testid={`manifesto-item-${i}`}
              >
                <span className="font-heading font-black text-6xl md:text-7xl text-[#0033A2] leading-none tracking-tighter block mb-4 md:mb-0">
                  {m.no}
                </span>
                <div>
                  <h3 className="font-heading font-bold text-2xl md:text-3xl tracking-tight leading-tight text-black">
                    {m.title}
                  </h3>
                  <p className="mt-4 text-black/65 font-medium text-lg leading-relaxed">
                    {m.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
